import axiosClient from "../helpers/axiosClient";

export function getLeaderboard() {
    return axiosClient.get('/leaderboard');
}